import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import Icon from './icon.esm.js';
import { animatedRotation } from '../../../themes/const.esm.js';

var _excluded = ["className", "toggleState", "initialIconOrientation", "rotateIconOnToggle", "sx"];
var ToggleFlipIcon = function ToggleFlipIcon(props) {
  var className = props.className,
    toggleState = props.toggleState,
    initialIconOrientation = props.initialIconOrientation,
    rotateIconOnToggle = props.rotateIconOnToggle,
    sx = props.sx,
    rest = _objectWithoutProperties(props, _excluded);
  var sxStyles = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, sx), animatedRotation(initialIconOrientation, rotateIconOnToggle));
  }, [initialIconOrientation, rotateIconOnToggle, sx]);
  return /*#__PURE__*/React.createElement(Icon, _extends({
    className: classNames({
      'is-toggle': toggleState
    }, className)
  }, rest, {
    sx: sxStyles
  }));
};

export default ToggleFlipIcon;
//# sourceMappingURL=toggle-flip-icon.esm.js.map
